import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type {
  AddQuoteFilesToComponentQueryVars,
  ComponentData,
  MutationFunction,
} from '@frontend/api';

export const getAddQuoteFilesAsSupportingFilesKey = () =>
  ['quotes', 'supportingFiles', 'addAsSupportingFiles'] as const;

export const useAddQuoteFilesAsSupportingFiles: MutationFunction<
  ComponentData,
  AddQuoteFilesToComponentQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/merge_quote_files_as_supporting_files`, {
        init: { method: 'POST', body },
      }),
    ...queryOptions,
    mutationKey: getAddQuoteFilesAsSupportingFilesKey(),
  });
};
